import { render, staticRenderFns } from "./consulta_articulos_por_cliente.vue?vue&type=template&id=79b1f402&"
import script from "./consulta_articulos_por_cliente.vue?vue&type=script&lang=js&"
export * from "./consulta_articulos_por_cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports